import { render, staticRenderFns } from "./UserTasksCard.vue?vue&type=template&id=2928fb2c&scoped=true"
import script from "./UserTasksCard.vue?vue&type=script&lang=js"
export * from "./UserTasksCard.vue?vue&type=script&lang=js"
import style0 from "./UserTasksCard.vue?vue&type=style&index=0&id=2928fb2c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2928fb2c",
  null
  
)

export default component.exports